module.exports = __webpack_public_path__ + "img/购物车.957726cc.png";